<template>
    <div v-if="isMounted && guarantee.guarantee_id != null">
        <div class="vx-row mt-2 mb-5">
            <div class="vx-col w-full">
                <div class="flex flex-center">
                    <vs-button @click.stop="requestSendNotification" size="small" color="#303f9f">
                        Notificar de llamada a OS
                    </vs-button>
                    <!-- <vs-chip transparent color="primary">
                        <vs-avatar icon="phone" />
                        <span class="bold text-xs">Notificar de llamada a Obligad@ Solidari@</span>
                    </vs-chip>
                    <vs-button size="small" radius class="ml-2" icon-pack="feather" icon="icon-send"
                        @click.stop="requestSendNotification"></vs-button> -->
                </div>
            </div>
        </div>
        <div class="flex mb-4">
            <vs-button @click.stop="executeRequestGuaranteeReminder(guarantee.guarantee_id, 1)" class="mr-2" color="warning" size="small">NOTIFICAR ONBOARDING DE OS</vs-button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "OsNotificationButton",
    props: {
        project: { type: [Object], required: true }
    },
    data() {
        return {
            guarantee: null,
            isMounted: false
        }
    },
    async beforeMount() {
        this.getGuaranteeInformation();
    },
    computed: {
        //TODO
    },
    methods: {
        ...mapActions('projects', [
            'requestGuaranteeReminder'
        ]),
        async executeRequestGuaranteeReminder(guaranteeId, reminderType) {
            this.showLoading(true);
            await this.requestGuaranteeReminder({
                guaranteeId: guaranteeId
                , flow: reminderType
            });
            this.showLoading(false);
        },
        async getGuaranteeInformation(){
            try {
                const res = await axios.get(`/api/v1/projectInfo/${this.project.finance.id}/guarantee`);
                this.guarantee = res.data;
                this.isMounted = true;
            } catch (error) {
                console.error(error);
            }
        },
        requestSendNotification(){
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title:  "Notificación de Obligado Solidario",
                text: `Se enviará un mensaje de whatsapp al teléfono <<${this.guarantee.phone}>> y correo a la dirección <<${this.guarantee.email}>> para contactar a <<${this.guarantee.name}>> ¿Deseas continuar?`,
                acceptText: "Confirmar",
                cancelText: 'Cancelar',
                accept: this.doSendNotification
            });
        },
        async doSendNotification(){
            try {
                const payload = {
                    project_id: this.project.id,
                    guarantee_id: this.guarantee.guarantee_id,
                    phone: this.guarantee.phone
                }
                await axios.post(`/api/notification/send-guarantee-call`, payload);
                this.saveSuccessNotif();
            } catch (error) {
                this.failedOperationNotif();
                console.error(error);
            }
        }
    }
}
</script>

<style scoped>

</style>